import React, { useState, useEffect, useCallback } from 'react';

import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';

import Subscription from './Subscription';
import SessionLimits from './SessionLimits';

const COMPONENTS = [
    {
        title: 'Subscription',
        component: 'Subscription',
    },
    {
        title: 'Session Limits',
        component: 'SessionLimits',
    },
];

const COMPONENT_MAP = {
    Subscription,
    SessionLimits,
};

const DEFAULT_PANEL_COMPONENT = COMPONENTS[0].component;

const ALLOWED_DETAIL_PANELS = new Set(COMPONENTS.map(({ component }) => component));

/** @param {object} [query] */
function resolvePanelFromQuery(query) {
    const key = query && query.panel;
    if (key && ALLOWED_DETAIL_PANELS.has(key)) {
        return key;
    }
    return DEFAULT_PANEL_COMPONENT;
}

const UserDetails = (props) => {
    const { params, router } = props;

    const routeUserId = params ? params.id : undefined;

    const resolvedLocation =
        props.location ||
        (router && router.location) ||
        null;

    const searchSuffix =
        resolvedLocation && typeof resolvedLocation.search === 'string'
            ? resolvedLocation.search
            : '';
    const [data, setData] = useState({});
    const [component, setComponent] = useState(() =>
        resolvePanelFromQuery(resolvedLocation && resolvedLocation.query));

    const fetchUser = useCallback(async () => {
        if (!routeUserId) return;

        const result = await api.users.getOne(routeUserId);

        if (result.status === 200) {
            setData(result.data);
            return;
        }

        const errorMsg = getNormalErrors(result).error;
        showNotification(errorMsg, 'error');
    }, [routeUserId]);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    useEffect(() => {
        const loc =
            props.location ||
            (props.router && props.router.location) ||
            null;
        setComponent(resolvePanelFromQuery(loc && loc.query));
    }, [routeUserId, searchSuffix]);

    const {
        name = '',
        surname = '',
        email = '',
        role = '',
    } = /** @type {{ name?: string, surname?: string, email?: string, role?: string }} */ (data);

    const safePanel =
        component && ALLOWED_DETAIL_PANELS.has(component) ? component : DEFAULT_PANEL_COMPONENT;
    const DetailPanel = COMPONENT_MAP[safePanel] || COMPONENT_MAP[DEFAULT_PANEL_COMPONENT];

    return (
        <div className='container user-page'>
            <div className='row'>
                <div className='col-md-4'>
                    <div style={{
                        padding: '20px',
                        minHeight: '400px',
                        borderRight: '1px solid rgb(158, 158, 158)',
                    }}
                    >
                        <div className='row'>
                            <div className='col-md-12 m-b-1 b-b-1 p-b-1'>
                                <h4>USER INFO</h4>
                                <div>NAME:</div>
                                <div>{`${name} ${surname}`}</div>
                                <div className='m-t-1'>EMAIL:</div>
                                <div>{email}</div>
                                <div className='m-t-1'>ROLE:</div>
                                <div>{role}</div>
                            </div>
                            <div className='col-md-12'>
                                {
                                    COMPONENTS.map(menuItem => (
                                        <div
                                            key={menuItem.component}
                                            className={`menu-item ${menuItem.component === component ? 'active' : ''}`}
                                            onClick={() => setComponent(menuItem.component)}
                                            role='button'
                                            tabIndex={0}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    setComponent(menuItem.component);
                                                }
                                            }}
                                        >
                                            {menuItem.title}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-8'>
                    <div style={{ padding: '20px' }}>
                        <DetailPanel
                            data={data}
                            fetchUser={fetchUser}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserDetails;



// WEBPACK FOOTER //
// ./app/components/Users/Details/index.jsx